import React from 'react';
import { Columns, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

/**
 * „Spalten auswählen“ / Ansicht anpassen — Checkboxen für sichtbare Spalten.
 */
export default function ColumnPicker({
  columns = [],
  onColumnsChange,
  label = 'Spalten',
  testId = 'column-picker',
}) {
  if (!onColumnsChange || columns.length === 0) return null;

  const toggle = (key) => {
    onColumnsChange(
      columns.map((c) => (c.key === key ? { ...c, visible: !c.visible } : c)),
    );
  };

  const showAll = () => {
    onColumnsChange(columns.map((c) => ({ ...c, visible: true })));
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-7 text-xs" data-testid={testId}>
          <Columns className="w-3.5 h-3.5 mr-1" />
          {label}
          <ChevronDown className="w-3 h-3 ml-1" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56" align="end" data-testid={`${testId}-popover`}>
        <div className="space-y-2">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-medium">Sichtbare Spalten</p>
            <button
              type="button"
              className="text-[11px] text-brand-red hover:underline"
              onClick={showAll}
              data-testid={`${testId}-show-all`}
            >
              Alle
            </button>
          </div>
          {columns.map((col) => (
            <label key={col.key} className="flex items-center gap-2 cursor-pointer text-sm">
              <input
                type="checkbox"
                checked={col.visible !== false}
                onChange={() => toggle(col.key)}
                data-testid={`${testId}-toggle-${col.key}`}
              />
              <span>{col.label}</span>
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
